module.exports = __webpack_public_path__ + "img/seback.02780c77.svg";